// src/services/contactService.js

import apiClient from './apiClient';

const api = apiClient;

export const submitContact = async ({ name, email, subject, message }) => {
  const res = await api.post('/api/contact', { name, email, subject, message });
  return res.data;
};

export default { submitContact };


